import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import { MessageStore } from '../stores/messageStore';

@observer
class Message extends Component {
  render() {
    const { messages, showMessage } = this.props.messageStore;
    return (
      <div>
        {messages.map(messageObj => (
          <Alert key={messageObj.message + 'id'} color={messageObj.messageType} isOpen={showMessage}>
            <span
              className={messageObj.messageType === 'success' ? 'icon icon-ok-circle' : 'icon icon-attention-circle'}
            />
            <span> {messageObj.message} </span>
          </Alert>
        ))}
      </div>
    );
  }
}

export default Message;

Message.propTypes = {
  messageStore: PropTypes.instanceOf(MessageStore).isRequired,
};
